/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/

import { SupportedLanguages } from '@common/enums/supported-languages.enum';

export enum EIcons {
  sort = 'sort',
  back_arrow = 'back_arrow',
  delete = 'delete',
  logo = 'logo',
  logo_text = 'logo_text',
  roles = 'roles',
  organization = 'organization',
  settings = 'settings',
  two_buildings = 'two_buildings',
  monitoring = 'monitoring',
  warning = 'warning',
  people_custom = 'people_custom',
  patients = 'patients',
  aid = 'aid',
  lab = 'lab',
  list = 'list',
  rhythm = 'rhythm',
  warning_custom = 'warning_custom',
  member_custom = 'member_custom',
  syringe = 'syringe',
  save_custom = 'save_custom',
  schedule_custom = 'schedule_custom',
  new_tab_custom = 'new_tab_custom',
  error_warning = 'error_warning',
  notification_indicator = 'notification_indicator',
  play_arrow_custom = 'play_arrow_custom',
  laboratory = 'laboratory',
  timepicker_arrow = 'timepicker_arrow',
  calendar = 'calendar',
  calendar_set = 'calendar_set',
  allergy = 'allergy',
  complaint = 'complaint',
  diagnosis = 'diagnosis',
  examination = 'examination',
  prescription = 'prescription',
  procedure = 'procedure',
  vitals = 'vitals',
  vaccination = 'vaccination',
  analysis = 'analysis',
  appointment = 'appointment',
  support_custom = 'support_custom',
  deleted = 'deleted',
  tutor = 'tutor',
  clinic_custom = 'clinic_custom',
  clinic = 'clinic',
  clinic_active = 'clinic_active',
  individual = 'individual',
  individual_active = 'individual_active',
  invoices = 'invoices',
  en = SupportedLanguages.en,
  fr = SupportedLanguages.fr,
  pt = SupportedLanguages.pt,
  es = SupportedLanguages.es,
  schedule = 'schedule',
  camera = 'camera',
  camera_outline = 'camera_outline',
  delete_outline = 'delete_outline',
  google_logo = 'google_logo',
  pharmacy = 'pharmacy',
  create_invoice = 'create_invoice',
  upload = 'upload',
  info = 'info',
  info_t = 'info_t',
  subscription = 'subscription',
  clock = 'clock',
  department = 'department',
  service = 'service',
  user = 'user',
  event = 'event',
  face = 'face',
  description = 'description',
  store = 'store',
  admission = 'admission',
  visit = 'visit',
  accept = 'accept',
  sign = 'sign',
  edit_stroked = 'edit_stroked',
  feedback = 'feedback',
  calendar_today = 'calendar_today',
  dictate_microphone = 'dictate_microphone',
  resources = 'resources',
  statistics = 'statistics',
  insurance_providers = 'insurance_providers',
  whatsapp = 'whatsapp',
  communication = 'communication',
  convert_to_admission = 'convert_to_admission',
  fluid_in = 'fluid_in',
  fluid_out = 'fluid_out',
  fetus = 'fetus',
  visa_light = 'visa_light',
  mastercard_color = 'mastercard_color',
  diagnoses = 'diagnoses',
  lab_2 = 'lab_2',
}
